module.exports = __webpack_public_path__ + "media/images/countryrect/ad-2283f635fd3824a99a08e9aee581c2d6.svg";